const getters = {
  instrument_trading_notes: state => instrument_id => {
    return state.trading_notes.filter(
      trading_note => trading_note.instruments.includes(instrument_id)
    )
  }
}

export default getters
